import React from 'react';

import { useIntl } from 'react-intl-next';

import { Stack, Text } from '@atlaskit/primitives/compiled';
import { TabPanel } from '@atlaskit/tabs';

import { MinionInvocationItem } from '../debug-items/minions-output';
import { messages } from '../messages';
import type { MinionOutput } from '../types';

import { Panel } from './panel-wrapper';

type MinionsInvokedPanelProps = {
	minionOutputs: MinionOutput[];
};

export const MinionsInvokedPanel = ({ minionOutputs }: MinionsInvokedPanelProps) => {
	const { formatMessage } = useIntl();

	return (
		<TabPanel>
			<Panel>
				<Stack space="space.0">
					{minionOutputs.length > 0 ? (
						minionOutputs.map((minion, index) => (
							<MinionInvocationItem key={minion.minion_id || index} minion={minion} index={index} />
						))
					) : (
						<Text>{formatMessage(messages.ai_debugger_modal_no_minions_invoked)}</Text>
					)}
				</Stack>
			</Panel>
		</TabPanel>
	);
};
